import * as React from 'react'
import ItemDragPreview from '../item-drag-preview'
import { SelectableItem } from '@disco/types/types/selection'

/**
 * Preview list component that renders a list of drag preview items
 * Maps over an array of items and renders appropriate preview components
 * @param list - Array of playlist or track items to display as previews
 */
const PreviewList = ({
  list,
}: {
  list: SelectableItem[]
}): React.ReactElement<'div'> => {
  const items = list.map((item, index) => (
    <ItemDragPreview item={item} key={index} />
  ))
  return <div>{items}</div>
}

export default PreviewList
